import { isDevMode } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const isDevMode_NotTests: typeof isDevMode = 'jasmine' in window ?
  () => false :
  isDevMode;

// Log stuff only in dev mode, not in prod.
//
// usage: for stuff that could log a lot in specific cases for devs to see,
// but normally wouldn't be useful in prod; more like trace logs in C#
// notes: pass in a function instead of args directly, so that it doesn't get evaluated ahead of time if it's not gonna be logged
export function logInDevMode_NotTests(params: () => any[]): void {
  // This is a noop for now for tests, so that there is not a bunch of extraneous logs in the tests,
  // until we can find a better way to do this, I guess
  if (isDevMode_NotTests()) {
    console.log(...params());
  }
}

export function logInDevMode(params: () => any[]): void {
  if (isDevMode()) {
    console.log(...params());
  }
}
